export enum BetType {
    // BBMinBet = 0,

    //Normal
    BBTie = 0,
    BBPlayerWin = 1,
    BBBankerWin = 2,
    BBPlayerPair = 3,
    BBBankerPair = 4,

    //Super
    BBS2CardsLuckySix = 5,
    BBS3CardsLuckySix = 6,
    BBSTotalPointOdd = 7,
    BBSSS2CardsLuckySix = 8,
    BBSSS3CardsLuckySix = 9,
    BBSTotalPointEven = 10,
    BBSPlayerPointSmall = 11,
    BBSBankerPointSmall = 12,
    BBSTotalPointSmall = 13,
    BBSPlayerPointBig = 14,
    BBSBankerPointBig = 15,
    BBSTotalPointBig = 16,
    BBSPlayerCardSmall = 17,
    BBSBankerCardSmall = 18,
    BBSTotalCardSmall = 19,
    BBSPlayerCardBig = 20,
    BBSBankerCardBig = 21,
    BBSTotalCardBig = 22,
    BBPlayerBonus = 23,
    BBBankerBonus = 24,

    //Super Six
    BBSSTie = 25,
    BBSSPlayerWin = 26,
    BBSSBankerWin = 27,
    BBSSPlayerPair = 28,
    BBSSBankerPair = 29,
    BBSSSuperSix = 30,

    //Super Added
    BBSTie = 31,
    BBSPlayerWin = 32,
    BBSBankerWin = 33,
    BBSPlayerPair = 34,
    BBSBankerPair = 35,

    //Natural Added
    BBPlayerNatural = 36,
    BBBankerNatural = 37,
    BBSPlayerNatural = 38,
    BBSBankerNatural = 39,
    BBSSPlayerNatural = 40,
    BBSSBankerNatural = 41,

    BBAnyPair = 42,
    BBSSAnyPair = 43,
    BBPerfectPair = 44,
    BBSSPerfectPair = 45,
    BBCowBankerPair = 46,
    BBCowPlayerNatural = 47,
    BBCowBankerNatural = 48,

    //Super Six Side Added
    BBSSSTotalCardSmall = 49,
    BBSSSTotalCardBig = 50,
    BBSSPlayerBonus = 51,
    BBSSBankerBonus = 52,
    BBSSSLuckySix = 53,

    //Side
    BBSLuckySix = 54,

    BBMaxBet = BBSLuckySix,
}
